import { BackgroundIcon1 } from "../../../assets/svg";
import Image_16 from "../../../assets/16.jpeg";

const AboutHero = () => {
  return (
    <div className="relative ">
      <BackgroundIcon1 position="top-[50%] right-[5%]" />
      <BackgroundIcon1 position="top-[10%] left-[5%]" />
      <div className="flex flex-col items-center md:h-[70vh] px-4 md:px-20 mt-12">
        <div className="flex flex-col md:flex-row items-center justify-between w-full">
          <div className="flex flex-col max-w-xl">
            <h1 className="text-[30px] md:text-[60px] mb-5">Über uns</h1>
            <p className="text-[14px] md:text-lg text-black font-semibold text-xl mb-3 md:mb-0">
              Wir haben es uns zur Aufgabe gemacht, außergewöhnliche Bau- und
              Instandhaltungsdienstleistungen für alle Arten von Immobilien
              anzubieten. Unsere Mission ist es, funktionale, sichere und
              ästhetisch ansprechende Räume zu schaffen und zu erhalten. Mit
              unserer Erfahrung und unserem Engagement für Qualität sorgen wir
              dafür, dass Ihre Projekte professionell und termingerecht
              umgesetzt werden. Vertrauen Sie uns, um Ihre Visionen Wirklichkeit
              werden zu lassen.
            </p>
          </div>
          <img
            src={Image_16}
            className="w-[500px] h-[500px] rounded-xl mb-12 md:mb-0 z-10 object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutHero;
